import React, { useState } from 'react';
import './qualification.css'

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    }

  return (
    <section className='qualification section' id='qualification'>
        <h2 className='section__title'>Qualification</h2>
        <span className='section__subtitle'>My personal journey</span>
    
    <div className='qualification__container container'>
        <div className='qualification__tabs'>
            <div className={toggleState === 1  ? 'qualification__button qualification__active button--flex' : 'qualification__button button--flex'}
            onClick={() => toggleTab(1)}>
                <i className='uil uil-graduation-cap qualition__icon'>
                </i> Education
            </div>

            <div className={toggleState === 2  ? 'qualification__button qualification__active button--flex' : 'qualification__button button--flex'}
            onClick={() => toggleTab(2)}>
                <i className='uil uil-briefcase-alt qualition__icon'>
                </i> Experience
            </div>
        </div>

        <div className='qualification__section'>
            <div className={toggleState === 1 ? 'qualification__content qualification__content-active':'qualification__content'}>
                <div className='qualification__data'>
                    <div>
                        <h3 className='qualification__title'>Web design</h3>
                        <span className='qualification__subtitle'>
                            Boolean Academy
                        </span>

                        <div className='qualification__calendar'>
                            <i className='uil uil-calendar-alt'>
                            </i> 2021 - Present
                            </div>
                        </div>

                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                </div>

                <div className='qualification__data'>
                    <div></div>

                    <div>
                        <span className='qualification__rounder'></span>
                        <span className='qualification__line'></span>
                    </div>

                    <div>
                        <h3 className='qualification__title'>Data analyst</h3>
                        <span className='qualification__subtitle'>
                            Boolean Academy
                        </span>

                        <div className='qualification__calendar'>
                            <i className='uil uil-calendar-alt'>
                            </i> 2020 - 2021
                        </div>
                    </div>

                </div>

                <div className='qualification__data'>
                    <div>
                        <h3 className='qualification__title'>Swift coding</h3>
                        <span className='qualification__subtitle'>
                            Apple Inc.
                        </span>

                        <div className='qualification__calendar'>
                            <i className='uil uil-calendar-alt'>
                            </i> 2019 - 2020
                            </div>
                        </div>

                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                </div>

                <div className='qualification__data'>
                    <div></div>

                    <div>
                        <span className='qualification__rounder'></span>
                        <span className='qualification__line'></span>
                    </div>

                    <div>
                        <h3 className='qualification__title'>Cybersecurity</h3>
                        <span className='qualification__subtitle'>
                            Cisco Systems, Inc.
                        </span>

                        <div className='qualification__calendar'>
                            <i className='uil uil-calendar-alt'>
                            </i> 2018 - 2019
                        </div>
                    </div>

                </div>

            </div>

            <div className={toggleState === 2 ? 'qualification__content qualification__content-active':'qualification__content'}>

                <div className='qualification__data'>
                    <div>
                        <h3 className='qualification__title'>Product Designer</h3>
                        <span className='qualification__subtitle'>
                            Microsoft - Milan, IT
                        </span>

                        <div className='qualification__calendar'>
                            <i className='uil uil-calendar-alt'>
                            </i> 2021 - Present
                            </div>
                        </div>

                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                </div>

                <div className='qualification__data'>
                    <div></div>

                    <div>
                        <span className='qualification__rounder'></span>
                        <span className='qualification__line'></span>
                    </div>

                    <div>
                        <h3 className='qualification__title'>UX Designer</h3>
                        <span className='qualification__subtitle'>
                            Apple Inc. - Milan, IT
                        </span>

                        <div className='qualification__calendar'>
                            <i className='uil uil-calendar-alt'>
                            </i> 2020 - 2021
                        </div>
                    </div>

                </div>

                <div className='qualification__data'>
                    <div>
                        <h3 className='qualification__title'>Web Designer</h3>
                        <span className='qualification__subtitle'>
                            Google Inc.
                        </span>

                        <div className='qualification__calendar'>
                            <i className='uil uil-calendar-alt'>
                            </i> 2019 - 2020
                            </div>
                        </div>

                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                </div>

            </div>
        </div>
    </div>
    </section>
  )
}

export default Qualification
